

export default {

    head() {
        return {
            title: (this.city) ?
                `Evaluez ${this.city.full_name} - ${this.$config.siteTitle}`
                : `Evaluez votre commune - ${this.$config.siteTitle}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: (this.city) ?
                        `Donnez votre avis sur ${this.city.full_name} (${this.city.region.fr_code_dep} - ${this.city.region.name}).` +
                        ` Sécurité, offre de transport, culture ou prix immobiliers, évaluez votre ville.`
                        : 'Donnez votre avis sur la qualité de vie dans votre commune, ' +
                        'la sécurité dans votre ville , l\'offre de transport, la culture ou les prix immobiliers.'
                },
                // add noindex,follow only if city is not defined
                {
                    hid: 'robots',
                    name: 'robots',
                    content: (this.city) ? 'noindex,follow' : 'index,follow'
                }
            ]
        }
    },

    async asyncData({ $axios, route, $config: { baseApiURL } }) {

        const props = {};
        if (route.query.city) {
            const props = await $axios.$get(`${baseApiURL}/cities/${route.query.city}`);
            return {
                city: props.city,
                displaySearchCard: false,
                initScoreGlobal: (route.query.global) ? parseInt(route.query.global) : 0
            }
        }
        return props;
    },

    data() {
        return {
            city: null,
            token: '',
            displaySearchCard: true,
            initScoreGlobal: 0
        };
    },
    methods: {
        selectCity(hit) {
            this.$axios.get(`${this.$config.baseApiURL}/cities/${hit.slug}`)
                .then(response => {
                    this.city = response.data.city;
                })
        }
    }
}
